export default __webpack_public_path__ + "static/coca_cola_logo.png";